<div id="container" class="rememberPwdPage bg-gradient-login mb-5" >
    <main id="home">
        <div class="logo">
            Coripet
        </div>
        <div class="login-wrapper cutting-edge">
            <div class="sign-in">
                <h4 translate>common.imposta-nuova-password</h4>
                <form id="changePasswordForm" class="sign-in-form">
                    <div class="row">
                        <div class="input">
                            <div class="input-wrapper full">
                                <input type="password" name="password" [(ngModel)]="password" id="change-password" maxlength="15">
                                <label for="change-password" translate>common.password</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input">
                            <div class="input-wrapper full">
                                <input type="password" name="confirmPassword" [(ngModel)]="confirmPassword" id="confirm-password" maxlength="15">
                                <label for="confirm-password" translate>common.confirm-password</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <br/><br/>
                        <input type="button" id="btnSubmit" (click)="submitChangePassword()" class="btn success" value="{{'common.salva' | translate }}">
                    </div>
                </form>
            </div>
        </div>
    </main>
</div>